import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllSurveys(_obj, params) {
    const res = await axios.get('api/surveys/', { params });
    return res.data;
  },
  async getSurvey(_obj, id) {
    const res = await axios.get(`api/surveys/${id}/`);
    return res.data;
  },
  async createSurvey(_obj, data) {
    return axios.post('api/surveys/', data);
  },
  async updateSurvey(_obj, { id, data }) {
    return axios.patch(`api/surveys/${id}/`, data);
  },
  async deleteSurvey(_obj, id) {
    return axios.delete(`api/surveys/${id}/`);
  },
  async activateSurvey(_obj, id) {
    return axios.post(`api/surveys/${id}/activate/`);
  },
  async closeSurvey(_obj, id) {
    return axios.post(`api/surveys/${id}/close/`);
  },
  async getSurveyResponses(_obj, id) {
    const res = await axios.get(`api/surveys/${id}/responses/`);
    return res.data;
  },
};

export const survey = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
